/**
 * Bugsnag onError filters.
 *
 * Each filter receives the original error and returns `false` to discard
 * the event (i.e. don't send it to Bugsnag) or `true` to keep it.
 *
 * To add a new filter just append a function to the `filters` array.
 */

const isCanceledRequest = err =>
  err?.message === "canceled" ||
  err?.code === "ERR_CANCELED" ||
  err?.name === "CanceledError";

const isNetworkError = err =>
  err?.message === "Network Error" || err?.code === "ERR_NETWORK";

const filters = [isCanceledRequest, isNetworkError];

/**
 * Runs all filters against the error.
 *
 * Usage inside Bugsnag.start():
 *   onError: bugsnagOnError
 */
export const bugsnagOnError = event => {
  const err = event.originalError;

  for (const filter of filters) {
    if (filter(err)) return false;
  }

  return true;
};
